export const config = {
	interval: {
		note: {
			autosave: 1,
			autotitle: 2,
			refresh: 10,
			refreshHidden: 120,
		},
		notes: {
			refresh: 25,
			refreshAfterHidden: 2,
		},
	},
}
